import React, { useEffect, useState } from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'
import RequestWithdrawal from '../../Dashboard/RequestWithdrawal';
import { useSelector } from 'react-redux';
import AdminWithdrawal from '../Withdrawal';
import Users from '../Users';
import Orders from '../Orders';
import Wallet from '../Wallet';
import { admimMe } from '../../../Services/AdminServices/adminAuthService';

const AdminBanner = () => {
    const [tab, setTab] = useState("withdrawal")
    const [me, setMe] = useState(null)

    const user = useSelector((state) => state.admin.data);

    console.log("user", user)

    const handleme = async () => {
        const response = await admimMe(user?.id);
        if (response?.code === 200) {
            setMe(response?.result?.user)
        }
    }

    useEffect(() => { handleme(); }, [])

    return (
        <>
            <div className="container-fluid ">
                <div className="card border-0 shadow-sm p-3">
                    <div className="row">
                        <div className="col-12">
                            <h2 className='fw-bold'>Admin Dashboard</h2>
                            <p className='text-muted '>Manage referrals, withdrawals, and user accounts</p>
                        </div>

                        <div className="col-lg-3">
                            <div className="card bg-light d-flex justify-content-center h-100 border-0 bg-light p-3">
                                <p className='text-muted mb-0'>Total Users</p>
                                <p className='fw-bold mb-0 s-22'>{me?.total_users}</p>
                            </div>
                        </div>



                        <div className="col-lg-3">
                            <div className="card bg-light    d-flex justify-content-center h-100 border-0 bg-light p-3">
                                <p className='text-muted mb-0'>Total Referrals</p>
                                <p className='fw-bold mb-0 s-22'>{me?.total_referals}</p>
                            </div>
                        </div>

                        <div className="col-lg-3">
                            <div className="card bg-light    d-flex justify-content-center h-100 border-0 bg-light p-3">
                                <p className='text-muted mb-0'>Pending Withdrawals</p>
                                <p className='fw-bold mb-0 s-22'>{me?.pending_payouts}</p>
                            </div>
                        </div>

                        <div className="col-lg-3">
                            <div className="card bg-light    d-flex justify-content-center h-100 border-0 bg-light p-3">
                                <p className='text-muted mb-0'>Total Withdrawn</p>
                                <p className='fw-bold mb-0 s-22'>{me?.total_withdrawals}</p>
                            </div>
                        </div>


                    </div>
                </div>

                <div className="col-lg-12 mt-4 d-none">
                    <div className='p-1 bg-light shadow-sm rounded'>
                        <ButtonGroup className='w-100' aria-label="Basic example">
                            <Button onClick={() => setTab("withdrawal")} variant={tab === "withdrawal" ? "primary" : ""}>Withdrawal</Button>
                            <Button onClick={() => setTab("user")} variant={tab === "user" ? "primary" : ""}>Users</Button>
                            <Button onClick={() => setTab("orders")} variant={tab === "orders" ? "primary" : ""}>Orders</Button>
                            <Button onClick={() => setTab("wallets")} variant={tab === "wallets" ? "primary" : ""}>Wallets</Button>
                        </ButtonGroup>
                    </div>
                </div>

                <div className="col-lg-12 mt-3 d-none">
                    <div className="card p-3">


                        {tab === "withdrawal" && (<AdminWithdrawal />)}
                        {tab === "user" && (<Users />)}
                        {tab === "orders" && (<Orders />)}
                        {tab === "wallets" && (<Wallet />)}
                    </div>

                </div>
            </div>
        </>
    )
}

export default AdminBanner